import { useRouter } from 'next/router';
import { useMemo } from 'react';
import { getQueryString, removeQueryParams } from '@framework/router';
import { IQueryParams } from '@/creditflowresearch/domain/vo/IQueryParams';
import { getFormatUrl } from '@/creditflowresearch/ui/common/helpers';
import { TabLink } from '@framework/router/Next/Link';
import { IBaseTabItem } from '@/creditflowresearch/domain/vo/IBaseTabItem';

interface IArticleTypeTabsProps<T> {
  tabs: T[],
  basePath: string,
  activeClassName: string,
  tabItemClassName?: string,
  onIsActive?: (tab: T) => boolean,
}

const ArticlesTypesTabs = <T extends IBaseTabItem>({
  tabs,
  basePath,
  activeClassName,
  tabItemClassName,
  onIsActive = () => false,
}: IArticleTypeTabsProps<T>) => {
  const { query: routeParams }:{ query: IQueryParams } = useRouter();
  const query = useMemo<IQueryParams>(
    () => removeQueryParams(routeParams, ['productType', 'articleType']),
    [routeParams],
  );

  return (
    <>
      {
        tabs.map((tab) => (
          <TabLink
            to={ getFormatUrl(`${ basePath }${ tab.url }?${ getQueryString(query) }`) }
            activeClassName={ activeClassName }
            className={ tabItemClassName }
            isActive={ onIsActive(tab) }
            dataTest={ tab.key }
            key={ tab.key }
          >
            <span>{ tab.label }</span>
          </TabLink>
        ))
      }
    </>
  );
};

export default ArticlesTypesTabs;
